/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TransactionSummary } from './TransactionSummary';
import {
    TransactionSummaryFromJSON,
    TransactionSummaryFromJSONTyped,
    TransactionSummaryToJSON,
} from './TransactionSummary';

/**
 * 
 * @export
 * @interface TransactionSummaryReport
 */
export interface TransactionSummaryReport {
    /**
     * 
     * @type {number}
     * @memberof TransactionSummaryReport
     */
    clientId: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionSummaryReport
     */
    clientFirstName: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionSummaryReport
     */
    clientLastName: string;
    /**
     * 
     * @type {TransactionSummary}
     * @memberof TransactionSummaryReport
     */
    transactionSummary: TransactionSummary;
}

/**
 * Check if a given object implements the TransactionSummaryReport interface.
 */
export function instanceOfTransactionSummaryReport(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "clientId" in value;
    isInstance = isInstance && "clientFirstName" in value;
    isInstance = isInstance && "clientLastName" in value;
    isInstance = isInstance && "transactionSummary" in value;

    return isInstance;
}

export function TransactionSummaryReportFromJSON(json: any): TransactionSummaryReport {
    return TransactionSummaryReportFromJSONTyped(json, false);
}

export function TransactionSummaryReportFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransactionSummaryReport {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'clientId': json['ClientId'],
        'clientFirstName': json['ClientFirstName'],
        'clientLastName': json['ClientLastName'],
        'transactionSummary': TransactionSummaryFromJSON(json['TransactionSummary']),
    };
}

export function TransactionSummaryReportToJSON(value?: TransactionSummaryReport | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ClientId': value.clientId,
        'ClientFirstName': value.clientFirstName,
        'ClientLastName': value.clientLastName,
        'TransactionSummary': TransactionSummaryToJSON(value.transactionSummary),
    };
}

